import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";

import { EventContext } from "@gp/components";

import { getCurrentCulture } from "@utils";

import { TLivePageUrlParams } from "@data-types/offer/live/LivePageUrlParams";
import { TPrematchPageUrlParams } from "@data-types/offer/prematch/PrematchPageUrlParams";
import { analyticsTracker } from "@utils/analytics";
import { BetBuilderActionsTypeEnum } from "@data-types/analytics-tracker/BetBuilderInteractionTypeEnum";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";

export default observer(function BetBuilderButton(props: {
	isOfferButton?: boolean;
	isSmallIcon?: boolean;
}) {
	const offerStore = useOfferContext();
	const event = useContext(EventContext);
	const navigate = useHistory();
	const params = useParams<TLivePageUrlParams | TPrematchPageUrlParams>();
	if (!event.betBuilder) {
		return null;
	}

	//#region css classes

	const buttonClasses = classNames(
		"at-actionStats",
		{
			match__details__btn: props.isOfferButton,
			event__top__btn: !props.isOfferButton,
		},
		"btn",
		{
			"btn--square--reset btn--ghost": props.isOfferButton,
			"btn--square btn--square--sml btn--secondary--inverted":
				!props.isOfferButton,
		}
	);

	const iconClasses = classNames(
		{
			match__details__icon: props.isOfferButton,
			event__actions__icon: !props.isOfferButton,
		},
		"u-icon u-icon--bb--active",
		{
			"u-icon--xsml": props.isOfferButton,
			"u-icon--sml": !props.isOfferButton,
			// "u-icon--tny": props.isSmallIcon,
			// "u-icon--sml": !props.isSmallIcon || !props.isOfferButton,
		}
	);
	//#endregion css classes
	const urlSearchParams = new URLSearchParams();
	urlSearchParams.append("bb", '"true"');

	let url = "";
	if ("period" in params) {
		url = `/${getCurrentCulture()}/sports/${params.period}/event/${
			event.id
		}?${urlSearchParams}`;
	}
	if (event.isLive && "section" in params) {
		url = `/${getCurrentCulture()}/live/${params.section}/event/${event.id}?${urlSearchParams}`;
	}

	return (
		<button
			className={buttonClasses}
			type="button"
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				analyticsTracker.trackBetBuilderInteraction(
					BetBuilderActionsTypeEnum.OpenBBwithShortcut
				);
				navigate.push(url, {
					eventIdsForEventSwitcher:
						offerStore.eventIdsForEventSwitcher,
				});
			}}
		>
			<i className={iconClasses} />
		</button>
	);
});
